import { ObservableArray, View } from "binder"
import { ISendPackageTab, SendPackageDetailViewModel } from "./sendPackageDetail-viewModel"

export class SendPackageDetailView extends View<SendPackageDetailViewModel>{
    GetViewUniqueId(): string {
        return "V-05EA6DC2-F98D-4C54-A7BE-1FED3454F00A"
    }
    loadHtml(): string {
        let element = require('./sendPackageDetail.html').default;
        let style = require('./sendPackageDetail.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId;} private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set receiveTime(v: moment.Moment) { this._receiveTime = v; } public get receiveTime(): moment.Moment { return this._receiveTime;} private _receiveTime: moment.Moment;
    public set sentTime(v: moment.Moment) { this._sentTime = v; } public get sentTime(): moment.Moment { return this._sentTime;} private _sentTime: moment.Moment;
    public set orderNumber(v: string) { this._orderNumber = v; } public get orderNumber(): string { return this._orderNumber;} private _orderNumber: string;
    public set packageNumber(v: number) { this._packageNumber = v; } public get packageNumber(): number { return this._packageNumber;} private _packageNumber: number;
    public set sendPackageState(v: number) { this._sendPackageState = v; } public get sendPackageState(): number { return this._sendPackageState;} private _sendPackageState: number;
    public set driverName(v: string) { this._driverName = v; } public get driverName(): string { return this._driverName;} private _driverName: string;
    public set canSend(v: boolean) { this._canSend = v; } public get canSend(): boolean { return this._canSend;} private _canSend: boolean;
    public set carNumber(v: string) { this._carNumber = v; } public get carNumber(): string { return this._carNumber;} private _carNumber: string;
    public set sendPackageTabs(v: ObservableArray<ISendPackageTab>) { this._sendPackageTabs = v; } public get sendPackageTabs(): ObservableArray<ISendPackageTab> { return this._sendPackageTabs;} private _sendPackageTabs: ObservableArray<ISendPackageTab>;
    public set selectedSendPackageTab(v: ISendPackageTab) { this._selectedSendPackageTab = v; } public get selectedSendPackageTab(): ISendPackageTab { return this._selectedSendPackageTab;} private _selectedSendPackageTab: ISendPackageTab;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    
    close(){
        this.dataContext.close();
    }

    send(){
        this.dataContext.send();
    }

    print(){
        this.dataContext.print();
    }
}
